import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from 'primereact/checkbox'
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Editor } from "primereact/editor";
import { Calendar } from 'primereact/calendar'
import { InputTextarea } from 'primereact/inputtextarea'
import { uniqueId } from "lodash"
import filesize from 'filesize'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { Tag } from 'primereact/tag'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList'

import { AuthContext } from '../../main/ProvedorAutenticacao'

import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import GrupoTrabalhoService from "../../app/service/GrupoTrabalhoService";
import AtividadeService from "../../app/service/AtividadeService";
import ResumoIntimacaoIaService from "../../app/service/ResumoIntimacaoIaService";

class AtividadeComponent extends Component {
	constructor(props) {
			super(props);

			this.state = {
				openSpinner: false,
				atividade: null,
				codigoAtividade: '',
				codigoProcesso: '',
				modalAtividade: false,
				tituloAtividade: null,
				descricao: '',
				dtLimite: null,
				processo: null,
				//Atividade
				pesquisaProcesso: '',
				partes: '',
				partesTabela: [],
				titulos: [],
				titulo: '',
				pontuacao: '',
				tituloAtividade: null,
				usuarioCriouAtividade: '',
				dataRegistroAtividade: '',
				grupoTrabalhoDescricao: '',
				subGrupoTrabalhoDescricao: '',
				codigoGrupo: '',
				codigoSubGrupo: '',
				selectSubGrupo: null,
				subGrupos: [],
				responsavel: null,
				responsaveis: [],
				interessado: null,
				interessados: [],
				recorrencia: null,
				optionStatus: [],
				statusCodigo: '',
				historico: [],
				statusAtividade: null,
				dtLimite: '',
				dataLimiteAntiga: '',
				horaAntiga: '',
				hora: '',
				dtFatal: '',
				grau: [],
				nomePessoa: '',
				codigoPublicacao: '',
				temResumoIntimacao: false,
				//Histórico
				dsHistorico: '',
				modalHistorico: false,
				tipoHistoricoLabel: '',
				tipoHistorico: '',
				historicoAtividade: null,
				//Arquivos
				exibirLinkAnexo: 'none',
				arquivos: [],
				displayArquivosAnexados: false,
				fileData: null,
        fileName: '',
        modalExibirArquivo: false,
        dsArquivo: '',
				arquivo: null,
				arquivoCodigo: '',
				upLoadFiles: [],
				modalDescricaoArquivo: false
			}

			this.tituloService = new TituloAtividadeService();
			this.grupoTrabalhoService = new GrupoTrabalhoService();
			this.arquivoAtividadeService = new ArquivoAtividadeService();
			this.atividadeService = new AtividadeService();
			this.resumoIntimacaoIaService = new ResumoIntimacaoIaService();

			this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
			this.onGrauChange = this.onGrauChange.bind(this);
			this.templateHistoricoAtividade = this.templateHistoricoAtividade.bind(this);
			this.acoesArquivos = this.acoesArquivos.bind(this);
			this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);

			this.recorrencia = [
				{codigo: '2', nome: '2'},
				{codigo: '3', nome: '3'},
				{codigo: '4', nome: '4'},
				{codigo: '5', nome: '5'},
				{codigo: '6', nome: '6'},
				{codigo: '7', nome: '7'},
				{codigo: '8', nome: '8'},
				{codigo: '9', nome: '9'},
				{codigo: '10', nome: '10'},
				{codigo: '11', nome: '11'},
				{codigo: '12', nome: '12'},
				{codigo: '13', nome: '13'},
				{codigo: '14', nome: '14'},
				{codigo: '15', nome: '15'},
				{codigo: '16', nome: '16'},
				{codigo: '17', nome: '17'},
				{codigo: '18', nome: '18'},
				{codigo: '19', nome: '19'},
				{codigo: '20', nome: '20'},
				{codigo: '21', nome: '21'},
				{codigo: '22', nome: '22'},
				{codigo: '23', nome: '23'},
				{codigo: '24', nome: '24'}
		];
	}

	listarTitulosAtividade = async (empresa) => {
		this.tituloService.listar(empresa)
		.then(response => {
				this.setState({titulos: response.data});
		}).catch(error => {
				this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
		})
	}

	consultarSubGrupos = async(codigo) => {
		await this.grupoTrabalhoService.listarSubGrupos(codigo)
		.then(response => {
				this.setState({subGrupos: response.data});
		}).catch(error => {
				this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
		})
	}

	onGrauChange(e) {
		let selectedGrau = [...this.state.grau];

		if (e.checked)
		selectedGrau.push(e.value);
		else
		selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

		this.setState({ grau: selectedGrau });
	}

	renderFooterAtividade(name) {
		return (
			<div className="left">
				<Button label="Alterar" 
								className="p-button-primary p-button-text"
								onClick={this.alterarAtividade}/>
				&nbsp;
				<Button label="Anexos" 
								icon="pi pi-paperclip"
								onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexados')}
								className="p-button-help p-button-text"/>
				&nbsp;
				<Button label="Novo Histórico"
								icon="pi pi-history"
								className="p-button-help p-button-text"
								onClick={this.novoHistorico}/>
				&nbsp;
				<Button label="Cancelar"
								className="p-button-secondary p-button-text"
								onClick={this.props.onHide}/>
			</div>
		);
	}

	async abrirModalArquivosAnexos(name, position){
    this.setState({openSpinner: true});
    await this.listarArquivosAtividade()
    this.setState({openSpinner: false});
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

	async exibirArquivo(arquivo){
    this.setState({openSpinner: true});
    await this.arquivoAtividadeService.exibirArquivo(arquivo.arquivo,this.state.atividade.codigo)
      .then(response => {
        const url = URL.createObjectURL(response.data); // Cria uma URL local para o arquivo
        this.setState({fileData: url});
        this.setState({fileName: arquivo.arquivo});
        this.abrirModal('modalExibirArquivo');
      }).catch(error => {
        this.setState({openSpinner: false});
        console.log("Erro ao buscar o arquivo", error);
      });
      this.setState({openSpinner: false});
  }
	
	async consultarArquivoDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModal('modalDescricaoArquivo');
  }

	 async download (rowData){
    //await this.consultarArquivo(rowData.codigo);
	  await this.arquivoAtividadeService.download(rowData.atividade.codigo,rowData.arquivo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', rowData.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

	excluirArquivo = () => {
		this.arquivoAtividadeService.excluirArquivo(this.state.arquivoCodigo)
			.then(response => {
				this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
				this.listarArquivosAtividade();
			}).catch(error => {
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
			})
	}
	
	confirmaExclusaoArquivo(arquivo) {
		this.setState({arquivoCodigo: arquivo.codigo});
		confirmDialog({
				message: 'Deseja realmente excluir este arquivo?',
				header: 'Exclusão de Arquivos',
				icon: 'pi pi-info-circle',
				acceptClassName: 'p-button-danger',
				acceptLabel: 'Sim',
				rejectLabel: 'Não',
				accept: this.acceptExcluirArquivo,
				reject: this.reject
		});
	}
	
	acceptExcluirArquivo() {
		this.excluirArquivo();
	}

	acoesArquivos(rowData) {
		return(
			<React.Fragment>
				<Button icon="pi pi-images" className="p-button-rounded p-button-text"
								tooltip="Consultar Arquivo"
								tooltipOptions={{position: 'top'}}
								onClick={() => this.exibirArquivo(rowData)}
								style={{width: '20px', height: '10px'}}/>
				&nbsp;
				<Button icon="pi pi-comment" className="p-button-rounded p-button-text"
								tooltip="Adicionar descrição ao arquivo"
								tooltipOptions={{position: 'top'}}
								onClick={() => this.consultarArquivoDescricao(rowData)}
								style={{width: '20px', height: '10px'}}/>
				&nbsp;
				<Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
								tooltip="Baixar Arquivo"
								onClick={() => this.download(rowData)}
								tooltipOptions={{position: 'top'}}
								style={{width: '20px', height: '10px'}}/>
				&nbsp;
				<Button icon="pi pi-trash" className="p-button-rounded p-button-text"
								tooltip="Excluir Arquivo"
								onClick={() => this.confirmaExclusaoArquivo(rowData)}
								tooltipOptions={{position: 'top'}}
								style={{width: '20px', height: '10px'}}/>
			</React.Fragment>
		);
	}

	listarArquivosAtividade = async () => {
    await this.arquivoAtividadeService.listarArquivos(this.state.atividade.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
        if(response.data.length > 0) {
          this.setState({exibirLinkAnexo: 'block'});
        } else {
          this.setState({exibirLinkAnexo: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

	pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

	alterarAtividade = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;

		if(this.state.responsavel == null) {
			this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
			return false;
		}

		if(this.state.dtLimite == '' || this.state.dtLimite == null) {
			this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
			return false;
		}

		let tipoTarefa = '';
		var dataFormatadaDataLimite = '';
		if(this.state.dtLimite != '' && this.state.dtLimite != null) {
			var date = this.state.dtLimite;
			var month = this.pad2(date.getMonth()+1);//months (0-11)
			var day = this.pad2(date.getDate());//day (1-31)
			var year= date.getFullYear();
			if(this.state.hora != '' && this.state.hora != null && this.state.hora != "00:00") {
				var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
				tipoTarefa = 'A';
			} else {
				var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
				tipoTarefa = this.state.tipo;
			}
		}

		var dataFormatadaDataFatal = null;
		if(this.state.dtFatal != '' && this.state.dtFatal != null) {
			var date = this.state.dtFatal;
			var month = this.pad2(date.getMonth()+1);//months (0-11)
			var day = this.pad2(date.getDate());//day (1-31)
			var year= date.getFullYear();
			if(this.state.hora != null && this.state.hora != '') {
				var dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
			} else {
				var dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
			}
		}

		var importante = 'N';
		var urgente = 'N';
		var privado = 'N';
		if(this.state.grau != null) {
			for(let i = 0; i < this.state.grau.length; i++) {
				if(this.state.grau[i] == 'importante') {
					importante = 'S';
				}

				if(this.state.grau[i] == 'urgente') {
					urgente = 'S';
				}

				if(this.state.grau[i] == 'privado') {
					privado = 'S';
				}
			}
		}

		const atividadeAlterar = {
			atividade: {
				codigo: this.state.atividade.codigo,
				titulo: this.state.titulo,
				tipo: tipoTarefa,
				descricao: this.state.descricao,
				usuario: usuarioLogado,
				processo: this.state.codigoProcesso ? { codigo: this.state.codigoProcesso } : null,
				dtLimite: dataFormatadaDataLimite,
				dtFatal: dataFormatadaDataFatal,
				status: this.state.optionStatus,
				subGrupo: {
					codigo: this.state.codigoSubGrupo,
					grupoPai: this.state.codigoGrupo
				},
				importante: importante,
				urgente: urgente,
				privado: privado
			},
			responsaveis: this.state.responsavel,
			interessados: this.state.interessado
		}

		var hora = "00:00";
		if(this.state.horaAntiga != null && this.state.horaAntiga != "") {
			hora = this.state.horaAntiga;
		}

		this.setState({openSpinner: true});
		await this.atividadeService.alterarAtividade(this.state.dataLimiteAntiga + " " + hora + ":00",
																								 this.state.statusCodigo, 
																								 usuarioLogado.codigo,
																								 atividadeAlterar)
			.then(response => {
				this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
				this.setState({openSpinner: false});
				this.props.onAtividadeAlterada(response.data);
				this.props.onHide();

			}).catch(error => {
				this.setState({ openSpinner: false });
        let mensagem = 'Ocorreu um erro inesperado. Tente novamente mais tarde.';
        if (error?.response?.data) {
          const data = error.response.data;
          if (typeof data === 'string') {
            mensagem = data;
          } else if (data.message) {
            mensagem = data.message;
          } else if (data.detail) {
            mensagem = data.detail;
          }
        }
        //Proteção contra toast null
        if (this.toast && typeof this.toast.show === 'function') {
          this.toast.show({
            severity: 'error',
            summary: 'Erro',
            detail: mensagem,
            life: 4000
          });
        } else {
          alert(mensagem);
        }
			});
	}

	templateCriacaoAtividade = () => {
		return(
			<div>Atividade criada por:&nbsp;&nbsp;
				<strong style={{color: '#ccc'}}>{this.state.usuarioCriouAtividade}&nbsp; em:&nbsp;{this.state.dataRegistroAtividade}</strong>
			</div>
		);
	}

	novoHistorico = () => {
    this.setState({tipoHistoricoLabel: 'Incluir Histórico',
									 tipoHistorico: '1',
									 dsHistorico: '',
									 modalHistorico: true,
		});
  }

	consultarAtividadeCustom = async(atividade) => {
		this.setState({atividade: atividade});
		this.setState({codigoAtividade: atividade.codigo});
		this.setState({codigoProcesso: atividade.codigoProcesso});
		this.setState({titulo: atividade.titulo});
		this.setState({pontuacao: atividade.pontos + " pontos"});
		this.setState({usuarioCriouAtividade: atividade.usuarioCriou});
		this.setState({dataRegistroAtividade: atividade.dataCriacao});
		this.setState({descricao: atividade.descricao});
		this.setState({grupoTrabalhoDescricao: atividade.grupo});
		this.setState({subGrupoTrabalhoDescricao: atividade.subGrupo});
		this.setState({codigoSubGrupo: atividade.codigoSubGrupo});
		this.setState({codigoGrupo: atividade.codigoGrupo});
		this.setState({tipo: atividade.tipo});
		if(atividade.processo != null) {
			this.setState({codigoProcesso: atividade.codigoProcesso});
			this.setState({partes: atividade.partes});
			this.setState({partesTabela: atividade.partesTabela || []});
			this.setState({pesquisaProcesso: atividade.processo});
		} else {
			this.setState({codigoProcesso: '', pesquisaProcesso: '', partes: '', partesTabela: []});
		}

		if(atividade.tipo == 'A') {
			this.setState({horaAntiga: atividade.hora})
			this.setState({hora: atividade.hora});
		}

		this.setState({dataLimiteAntiga: atividade.dataLimite});
		var dataLimite = new Date(atividade.dataLimite);
		dataLimite.setDate(dataLimite.getDate() + 1)
		this.setState({dtLimite: new Date(Date.parse(dataLimite))});
		if(atividade.prazoFatal != null) {
			var dataFatal = new Date(atividade.prazoFatal);
			dataFatal.setDate(dataFatal.getDate() + 1)
			this.setState({dtFatal: new Date(Date.parse(dataFatal))});
		} else {
			this.setState({dtFatal: ''});
		}

		this.setState({statusCodigo: atividade.statusCodigo});
		this.setState({optionStatus: atividade.statusEntty});
		this.setState({statusAtividade: atividade.status});

		let grau = [];
		if(atividade.importante == 'S') {
			grau.push('importante');
		}

		if(atividade.urgente == 'S') {
			grau.push('urgente');
		}

		if(atividade.privado == 'S') {
			grau.push('privado');
		}
		this.setState({grau: grau});
		this.setState({historico: atividade.historico});
		this.setState({nomePessoa: atividade.nomePessoa || ''});
		this.setState({codigoPublicacao: atividade.codigoPublicacao});
		this.setState({temResumoIntimacao: false});
		if (atividade.codigoPublicacao) {
			this.resumoIntimacaoIaService.consultarHistorico(atividade.codigoPublicacao)
				.then(response => {
					const temResumo = response.data.some(item => item.status === 'CONCLUIDO');
					this.setState({temResumoIntimacao: temResumo});
				})
				.catch(error => console.log('Erro ao consultar resumo de intimação', error));
		}
		//Responsáveis
		this.setState({responsavel: atividade.responsaveisAtividade});
		this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + atividade.responsaveisAtividade.length + ' )'});
		this.setState({responsaveis: atividade.usuariosGrupo});
		//Interessados
		this.setState({interessado: atividade.interessadosAtividade});
		if(atividade.interessadosAtividade != null) {
			this.setState({quantidadeInteressados: 'Atividade sem interessados'});
		} else {
			this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + atividade.interessadosAtividade.length + ' )'});
		}
		this.setState({interessados: atividade.usuariosGrupo});
	}

	templateHistoricoAtividade(data) {
		return (
			<div className="col-12">
				<div style={{display:'flex', alignItems:'center', gap:'8px', padding:'4px 8px 4px 0', marginBottom:'2px'}}>
					<strong style={{color: 'blue'}} className="grupoTrabalho">
						{data.usuario.nome} - {data.dtHistorico}
					</strong>
					{data.dataAlteracao && (
						<strong style={{color:'#888', fontWeight:400, fontSize:'12px'}}>
							&nbsp;· Editado em {data.dataAlteracao}
						</strong>
					)}
					<a onClick={() => this.consultarHistoricoAtividade(data)} style={{cursor:'pointer', marginLeft:'8px'}}>
						<i className="pi pi-pencil" title="Alterar Histórico"/>
					</a>
					<a onClick={() => this.confirmaExclusaoHistorico(data)} style={{cursor:'pointer'}}>
						<i className="pi pi-times-circle" title="Excluir histórico. Apenas o usuário que o escreveu pode executar esta ação"/>
					</a>
				</div>
				<div className="balao" style={{borderRadius: '6px'}}>
					<Editor value={data.dsHistorico}
						readOnly
						style={{ height: '120px' }} />
				</div>
				<br/>
			</div>
		);
	}

	fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

	salvarHistorico = () => {
		if(this.state.tipoHistorico == '1') {
			this.incluirHistorico();
		} else {
			this.alterarHistorico();
		}
	}

	incluirHistorico = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    let tipoHistorico = 'M';
    this.setState({openSpinner: true});
    await this.atividadeService.incluirHistorico({
      atividade: {
        codigo: this.state.atividade.codigo
      },
      dsHistorico: this.state.dsHistorico,
      usuario: usuarioLogado,
      tpHistorico: tipoHistorico
    }).then(response => {
      this.listarHistorico();
      this.setState({modalHistorico: false});
      this.toast.show({severity:'success', summary: 'Histórico de Atividades', detail:'Histórico incluído com sucesso', life: 4000});
      this.setState({openSpinner: false});
    }).catch(error => {
      this.setState({openSpinner: false});
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Histórico de Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

	async consultarHistoricoAtividade(historico){
    this.setState({openSpinner: true});
    await this.atividadeService.consultarHistoricoPorCodigo(historico.codigo)
      .then(response => {
        this.setState({});
        this.setState({tipoHistoricoLabel: 'Alterar Histórico',
											 tipoHistorico: '2',
					             historicoAtividade: response.data,
					             dsHistorico: response.data.dsHistorico,
											 modalHistorico: true,
											 openSpinner: false
				});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico da Atividade', detail:`${this.state.detail}`, life: 4000});
      })
  }

	alterarHistorico = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    const historico =  {
      codigo: this.state.historicoAtividade.codigo,
      usuario: usuarioLogado,
      tpHistorico: 'M',
      atividade: {
        codigo: this.state.atividade.codigo
      },
      dsHistorico: this.state.dsHistorico,
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarHistorico(historico)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Histórico de Atividade', detail:'Histórico alterado com sucesso!', life: 4000});
        this.listarHistorico();
        this.setState({openSpinner: false, modalHistorico: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Histórico de Atividade', detail:`${error}`, life: 4000});
      })
  }

	listarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.atividade.codigo)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

	async componentDidUpdate(prevProps){
		if(this.props.atividade && prevProps.atividade !== this.props.atividade){
			if(typeof this.props.atividade === 'object') {
				this.consultarAtividadeCustom(this.props.atividade);
			} else {
				const usuarioLogado = this.context.usuarioAutenticado;
				this.setState({ openSpinner: true });
				try {
					const response = await this.atividadeService.consultarAtividadeCustom(
						this.props.atividade,
						usuarioLogado.empresa.codigo,
						usuarioLogado.codigo
					);
					this.consultarAtividadeCustom(response.data);
				} catch(error) {
					this.toast.show({severity:'error', summary:'Atividades', detail:'Erro ao consultar atividade', life: 4000});
				} finally {
					this.setState({ openSpinner: false });
				}
			}
		}
	}

	fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

	async abrirModal(name, position){
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

	handleUpload = async files => {
		const upLoadFiles = files.map(file => ({
			file,
			id: uniqueId(),
			name: file.name,
			readableSize: filesize(file.size),
			progress: 0,
			uploaded: false, 
			error: false,
			url: file.url
		}))

		this.setState({
			upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
		});

		await upLoadFiles.forEach(this.processar);
	}

	processar = async (upLoadFile) => {
		const usuarioLogado = this.context.usuarioAutenticado;
		const data = new FormData();
		data.append('file',upLoadFile.file);
		data.append('atividade',upLoadFile.file, this.state.atividade.codigo) //Envia código de atividade para salvar os arquivos
		data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de atividade para salvar os arquivos
		await this.arquivoAtividadeService.incluirArquivo(data)
			.then(response => {
				this.listarArquivosAtividade();
				this.handleDelete(upLoadFile.id);
			}).catch(error => {
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
			})
	}

	handleDelete  = async id => {
		this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
	} 

	renderFooterDescricaoArquivo(name) {
		return (
				<div>

						<Button label="Cancelar" 
										className="p-button-secondary p-button-text"
										onClick={() => this.fecharModal(name)}/>
						&nbsp;
						<Button label="Alterar" 
										className="p-button-primary p-button-text"
										onClick={this.adicionarDescricao}/> 

			</div>
		);
	}

	adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      dsArquivo: this.state.dsArquivo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosAtividade();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModal('modalDescricaoArquivo');
  }

	render() {
		const { upLoadFiles } = this.state;
		const { visible, onHide } = this.props;
		return(
				<>
					<Toast ref={(el) => this.toast = el} />
					{this.props.visible && this.state.openSpinner && (
						<div style={{
							position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
							backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 99999,
							display: 'flex', alignItems: 'center', justifyContent: 'center',
						}}>
							<div className="spinner-border text-light" style={{ width: '4rem', height: '4rem' }} role="status" />
						</div>
					)}

					{/**Exibir arquivo */}
					<Dialog header="Arquivo"
									visible={this.state.modalExibirArquivo} 
									style={{ width: '60vw' }} 
									footer={
										<div>
												<Button label="Fechar" 
																className="p-button-secondary p-button-text"
																onClick={() => this.fecharModal('modalExibirArquivo')}/>
										</div>
									}
									onHide={() => this.fecharModal('modalExibirArquivo')}>
								<div className="row">
									<div className="col-sm-12">
										<div className="form-group">
											
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-sm-12">
										<div className="form-group">
											
										{this.state.fileData && (
												<div style={{ marginTop: "20px" }}>
														<h3>Arquivo:</h3>
														{this.state.fileName.toLowerCase().endsWith(".pdf") ? (
																<iframe
																		src={this.state.fileData}
																		title="PDF Viewer"
																		style={{ width: "100%", height: "500px", border: "1px solid #ddd" }}
																/>
														) : (
																<img
																		src={this.state.fileData}
																		alt={this.state.fileName}
																		style={{ maxWidth: "100%", maxHeight: "500px", border: "1px solid #ddd" }}
																/>
														)}
												</div>
										)}
	
	
									</div>
								</div>
							</div>
					</Dialog>

					{/**Arquivos Anexados */}
					<Dialog header="Arquivos Anexados"
								style={{ width: '40vw' }} 
								visible={this.state.displayArquivosAnexados} 
								footer={
									<frameElement>
										<Button label="Fechar" 
														className="p-button-secondary p-button-text"
														onClick={() => this.fecharModal('displayArquivosAnexados')}/>
									</frameElement>
									
								} 
								onHide={() => this.fecharModal('displayArquivosAnexados')}>
						
						<div className="row">
								<div className="col-sm-12">
									<div className="form-group">  
											
											<Upload onUpload={this.handleUpload}/>
											{!!upLoadFiles && (
												<FileList files={upLoadFiles} onDelete={this.handleDelete}/>
											)}
										
									</div>
								</div>
							</div>
							<DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
													paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
													currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
													emptyMessage="Nenhum Arquivo">
								<Column field="arquivo" header="Arquivo"/>
								<Column field="dsArquivo" header="Descrição"/>
								<Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
							</DataTable> 
					</Dialog>   
					{/**Adicionar descrição ao arquivo */}
					<Dialog header="Descrição do Arquivo"
									visible={this.state.modalDescricaoArquivo} 
									style={{ width: '40vw' }} 
									footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
									onHide={() => this.fecharModal('modalDescricaoArquivo')}>

							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<label htmlFor="descricaoArquivo">Descrição</label>
										<InputText id="descricaoArquivo" 
													type="text" 
													style={{width: '100%', height: '37px'}} 
													value={this.state.dsArquivo}
													onChange={e => this.setState({dsArquivo: e.target.value})}
													className="p-inputtext-sm p-d-block p-mb-1"/>
									</div>
								</div>
							</div>
					</Dialog>
					
					<Dialog header={this.templateCriacaoAtividade}
									visible={visible}
									style={{ width: '43vw' }} 
									footer={this.renderFooterAtividade('modalAtividade')} 
									onHide={onHide}>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<h5><strong style={{color: '#000'}}>{this.state.titulo} - {this.state.pontuacao}</strong></h5>
										{this.state.codigoPublicacao && (
											<div style={{display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px'}}>
												<i className="fas fa-link" style={{fontSize: '11px', color: '#5a72a0'}}></i>
												<span
													onClick={() => window.open(`#/publicacao/${this.state.codigoPublicacao}`, '_blank')}
													style={{color: '#1a73e8', fontSize: '13px', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline'}}>
													Acessar Publicação
												</span>
											</div>
										)}
									</div>
								</div>
							</div>
							<div>
						</div>
							<div className="row" style={{marginBottom: '12px'}}>
								<div className="col-sm-12">

									{this.state.nomePessoa && (
										<div style={{
											display: 'flex', alignItems: 'center', gap: '10px',
											background: '#f0f4ff', border: '1px solid #c7d4f0',
											borderRadius: '6px 6px 0 0',
											padding: '6px 12px',
										}}>
											<span style={{fontSize: '11px', fontWeight: 700, color: '#5a72a0', textTransform: 'uppercase', letterSpacing: '0.5px', minWidth: '90px'}}>Nome Pessoa</span>
											<span style={{color: '#1a3a6e', fontWeight: 600, fontSize: '13px'}}>{this.state.nomePessoa}</span>
										</div>
									)}

									{this.state.pesquisaProcesso ? (
										<>
											<div style={{
												display: 'flex', alignItems: 'center', gap: '10px',
												background: '#f0f4ff', border: '1px solid #c7d4f0',
												borderTop: this.state.nomePessoa ? 'none' : undefined,
												borderRadius: this.state.nomePessoa
													? (this.state.partesTabela?.length > 0 ? '0' : '0 0 6px 6px')
													: (this.state.partesTabela?.length > 0 ? '6px 6px 0 0' : '6px'),
												padding: '6px 12px',
											}}>
												<span style={{fontSize: '11px', fontWeight: 700, color: '#5a72a0', textTransform: 'uppercase', letterSpacing: '0.5px', minWidth: '62px'}}>Processo</span>
												<span style={{color: '#1a3a6e', fontWeight: 600, fontSize: '13px'}}>{this.state.pesquisaProcesso}</span>
											</div>
											{this.state.partesTabela?.length > 0 && (
												<div style={{border: '1px solid #c7d4f0', borderTop: 'none', borderRadius: '0 0 6px 6px', overflow: 'hidden'}}>
													<div style={{fontSize: '11px', fontWeight: 700, color: '#5a72a0', textTransform: 'uppercase', letterSpacing: '0.5px', padding: '4px 12px', background: '#f7f9ff', borderBottom: '1px solid #c7d4f0'}}>Partes</div>
													{this.state.partesTabela.map((parte, index) => (
														<div key={index} style={{
															display: 'flex', alignItems: 'center', gap: '8px',
															padding: '5px 12px',
															borderBottom: index < this.state.partesTabela.length - 1 ? '1px solid #eef1f8' : 'none',
															background: index % 2 === 0 ? '#fff' : '#fafbff',
															fontSize: '13px'
														}}>
															<span style={{color: '#1a3a6e', fontWeight: 500}}>{parte.pessoa.nome}</span>
															<span style={{color: '#b0bcd4', fontSize: '11px'}}>—</span>
															<span style={{color: '#5a72a0', fontSize: '11px'}}>{parte.nomeTipo}</span>
														</div>
													))}
												</div>
											)}
										</>
									) : (
										<div style={{
											display: 'flex', alignItems: 'center', gap: '10px',
											background: '#f9f9f9', border: '1px solid #e0e0e0',
											borderTop: this.state.nomePessoa ? 'none' : undefined,
											borderRadius: this.state.nomePessoa ? '0 0 6px 6px' : '6px',
											padding: '6px 12px',
										}}>
											<span style={{color: '#aaa', fontSize: '13px', fontStyle: 'italic'}}>Atividade sem Processo</span>
										</div>
									)}

								</div>
							</div>
							<div className="row">
								<div className="col-sm-6">
									<div className="form-group">
									<InputText id="grupoAlterar" style={{width: '100%', height: '32px'}}
															type="text"
															disabled="true"
															value={this.state.grupoTrabalhoDescricao}
															className="p-inputtext-sm p-d-block p-mb-1"/>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="form-group">
										<InputText id="subgrupoDescricao" 
																type="text" 
																disabled
																style={{width: '100%', height: '32px'}} 
																value={this.state.subGrupoTrabalhoDescricao}
																onChange={e => this.setState({subGrupoTrabalhoDescricao: e.target.value})}
																className="p-inputtext-sm p-d-block p-mb-1"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6">
									<div className="form-group">
										<MultiSelect inputId="multiselect" 
																value={this.state.responsavel} 
																options={this.state.responsaveis} 
																style={{width: '100%', height: '32px', padding_top: '1px'}} 
																onChange={(e) => this.setState({ responsavel: e.value })} 
																filter showClear filterBy="nome"
																optionLabel="nome" 
																placeholder="Responsáveis"/>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="form-group">
										<MultiSelect inputId="multiselect" 
																value={this.state.interessado} 
																options={this.state.interessados} 
																style={{width: '100%', height: '32px', padding_top: '1px'}} 
																onChange={(e) => this.setState({ interessado: e.value })}  
																filter showClear filterBy="nome"
																optionLabel="nome" 
																placeholder="Interssados"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-3">
									<div className="form-group">
										<Calendar id="mask" 
															value={this.state.dtLimite} 
															onChange={(e) => this.setState({ dtLimite: e.value })} 
															locale="es"
															style={{width: '100%', height: '32px'}} 
															dateFormat="dd/mm/yy"
															mask="99/99/9999"
															placeholder="Data Limite"/>
									</div>
								</div>
								<div className="col-sm-3">
									<div className="form-group">
									<InputMask id="hora" style={{width: '100%', height: '32px'}}
														type="text"
														mask="99:99"
														value={this.state.hora}
														onChange={e => this.setState({hora: e.target.value})}
														className="p-inputtext-sm p-d-block p-mb-1"/>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="form-group">
										<Calendar id="mask" 
															value={this.state.dtFatal} 
															onChange={(e) => this.setState({ dtFatal: e.value })} 
															locale="es"
															style={{width: '100%', height: '32px'}} 
															dateFormat="dd/mm/yy"
															mask="99/99/9999"
															placeholder="Prazo fatal"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
											<label>Descrição</label>
											{this.state.temResumoIntimacao && (
												<Tag value="Intimação Resumida" severity="info" icon="pi pi-sparkles" />
											)}
										</div>
										<InputTextarea value={this.state.descricao} style={{width: '100%'}}
																		id="descricaoE"
																		onChange={e => this.setState({descricao: e.target.value})}
																		rows={4}
																		cols={60} />
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<Dropdown value={this.state.optionStatus} style={{width: '100%', height: '32px'}} 
															options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
															optionLabel="status" 
															emptyMessage=" "
															filter showClear filterBy="status"
															onChange={e => this.setState({optionStatus: e.target.value})}
															id="idStatusAtividade"
															className="p-inputtext-sm p-d-block p-mb-1"/>
									</div>
								</div>
							</div>
							<br></br>
							<div className="row" style={{marginLeft: '12px'}}>
								<div className="col-sm-8">
									<div className="form-group">
										<label htmlFor="importante">
											<Checkbox inputId="importante" 
																name="importante" 
																value="importante" 
																onChange={this.onGrauChange} 
																checked={this.state.grau.indexOf('importante') !== -1} />
											&nbsp;&nbsp;
											Importante
											&nbsp;&nbsp;
											<Checkbox inputId="urgente" 
																name="urgente" 
																value="urgente" 
																onChange={this.onGrauChange} 
																checked={this.state.grau.indexOf('urgente') !== -1} />
											&nbsp;&nbsp;
											Urgente
											&nbsp;&nbsp;
											<Checkbox inputId="privado" 
																name="privado" 
																value="privado" 
																onChange={this.onGrauChange} 
																checked={this.state.grau.indexOf('privado') !== -1} />
											&nbsp;&nbsp;
											Privado
										</label>
									</div>
								</div>
							</div>
							<br></br>
							<br></br>
							<div className="row" style={{marginLeft: '12px'}}>
								<div className="col-sm-12">
									<div className="form-group">
										<span style={{fontSize: '14px', fontWeight: 'bold'}}>Histórico</span>
										<hr></hr>
									</div>
								</div>
							</div>
							<br></br>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<TabView className="tabview-custom">
											<TabPanel header="incluido pelo usuário">
												<DataView value={this.state.historico ? this.state.historico.filter(h => h.tpHistorico === 'M') : []}
														layout={this.state.layout}
														emptyMessage=" "
														itemTemplate={this.templateHistoricoAtividade}/>
											</TabPanel>
											<TabPanel header="Incluido pelo sistema">
												<DataView value={this.state.historico ? this.state.historico.filter(h => h.tpHistorico === 'A') : []}
														layout={this.state.layout}
														emptyMessage=" "
														itemTemplate={this.templateHistoricoAtividade}/>
											</TabPanel>
										</TabView>
									</div>
								</div>
							</div>
					</Dialog>
					{/**Incluir um novo histórico */}
					<Dialog header={this.state.tipoHistoricoLabel}
									style={{ width: '40vw' }} 
									visible={this.state.modalHistorico} 
									footer={
										<frameElement>
											<Button label="Salvar" 
															className="p-button-primary p-button-text"
															onClick={this.salvarHistorico}/>
											&nbsp;
											<Button label="Fechar" 
															className="p-button-secondary p-button-text"
															onClick={() => this.fecharModal('modalHistorico')}/>
										</frameElement>
										
									} 
									onHide={() => this.fecharModal('modalHistorico')}> 

						<div className="row">
							<div className="col-sm-12">
								<div className="form-group">
									<Editor value={this.state.dsHistorico} 
													onTextChange={e => this.setState({dsHistorico: e.htmlValue})} 
													style={{ height: '320px' }} />
								</div>
							</div>
						</div>  
					</Dialog>
				</>
		);
	}
}
AtividadeComponent.contextType = AuthContext;
export default AtividadeComponent;
